import { useEffect } from "react";
import { PhoneInput } from "react-international-phone";
import { message } from "antd";

import Select from "../../../../Components/Select";
import Input from "../../../../Components/Input";
import Button from "../../../../Components/Button";
import Textarea from "../../../../Components/Textarea";

import { useBranchesHelper } from "../useBranchesHelper";
import { queryClient } from "../../../../services/queryClient";
import { useUpdateBranchMutation } from "../../../../hooks/BranchManagement/useUpdateBranchMutation";

interface PayloadType {
  name: string;
  address: string;
  lga: string;
  countryCode: string;
  state: string;
  phoneNumber: string;
  id: string;
}

const EditBranch = ({
  selectedBranch,
  closeEditModal,
}: {
  selectedBranch: PayloadType;
  closeEditModal: () => void;
}) => {
  const { payload, states, setPayload, handleInputChange, handleStateChange } =
    useBranchesHelper();

  const { mutateAsync: updateBranch, isPending: isLoading } =
    useUpdateBranchMutation(selectedBranch?.id);

  useEffect(() => {
    if (selectedBranch && (!payload?.id || payload?.id !== selectedBranch.id)) {
      setPayload({
        ...selectedBranch,
      });
    }
  }, [selectedBranch, setPayload, payload]);

  return (
    <div>
      {/* {/* <p>{payload?.id}</p> */}
      {/* <p>{selectedBranch?.id}</p> */}
      <Input
        type={"text"}
        name={"name"}
        label={"Name"}
        value={payload?.name || ""}
        placeholder={"Enter branch name"}
        onChange={handleInputChange}
      />
      <label htmlFor="phoneNumber" className="mt-[20px]">
        Phone Number
      </label>
      <PhoneInput
        defaultCountry="ng"
        className="mt-[13px] mb-3 text-grey text-[16px] manrope capitalize"
        name="phoneNumber"
        value={payload?.phoneNumber || ""}
        onChange={(phone) => setPayload({ ...payload, phoneNumber: phone })}
      />
      <Select
        label={"State"}
        name={"state"}
        value={payload?.state || ""}
        options={states}
        onChange={handleStateChange}
      />
      <Textarea
        label="Address"
        name={"address"}
        value={payload?.address || ""}
        placeholder={"Enter Branch Address"}
        onChange={handleInputChange}
      />
      <Button
        className={
          "text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 bg-brown"
        }
        label={"Proceed"}
        isLoading={isLoading}
        onClick={() => {
          updateBranch(payload, {
            onSuccess: async () => {
              closeEditModal();
              queryClient.invalidateQueries({ queryKey: ["branches"] });
            },
            onError: (error: any) => {
              message.error(error?.response?.data?.message);
            },
          });
        }}
      />
    </div>
  );
};

export default EditBranch;
